module.exports = __webpack_public_path__ + "static/media/app_screens_2.4dd764c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_screens_2.png
// module id = 368
// module chunks = 0